import React from "react";
import { connect } from "react-redux";

import history from "./history";
import RESPONSE_HEADER from "./utils/enums/RESPONSE_HEADER";
import CONFIG from "./config";
import { console, contextPath, sendError } from "./utils/functions";

class ErrorBoundary extends React.Component {

  state = { error: null, info: null };

  static getDerivedStateFromError(error) {
    console.error(error);
    return ({ hasError: true, error });
  }

  componentDidCatch(error, info) {
    // Catch errors in any components below and re-render with error message
    if (this.state.hasError) {
      this.setState({
        error: error,
        info: info,
        hasError: true,
      });
      if (sendError(error, this.props.type)) {
        this.setState({ hasError: false });
      }
      let defaultMessage = "UNBEKANNT";        
      if (CONFIG.isKundenShop() && CONFIG.isVerseNeo()) {
        defaultMessage = "VNEO_UNBEKANNT";
      }
      console.log('ErrorBoundary', error, info);
      history.replace(contextPath(`${CONFIG.SHOP_ROOT}/error`), { messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT, messageText: RESPONSE_HEADER.ERRORMESSAGE[defaultMessage] });
    }
  }

  render() {
    if (this.state.hasError) {
      return <>
        <div className="error">{this.state.info}</div>
        {this.props.children}
      </>
    }
    return this.props.children;
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
  };
})(ErrorBoundary);
